export const ResourceAccessLevel = {
	PUBLIC: 0,
	VIEWER: 10,
	PARTICIPANT: 20,
	MODERATOR: 30,
	OPERATOR: 40,
	OWNER: 60,
};
